<template>
	<main class="single post main margin-top-lg margin-bottom-xl" :key="currentPageID" :class="'type-'+currentPostType">
		<template v-if="!isProtected" >
			<FeaturedImage class="container margin-bottom-lg container--large" size="large"/>
			<ModuleBuilder />

			<SocialShareArticle v-if="currentPostType ==='post'" class="container margin-both-lg" />
			
			<ConnectedEducations v-if="currentPostType ==='professions' || currentPostType ==='educations' || currentPostType ==='ambassadors'" class="container margin-both-lg" />
			
			<ConnectedAmbasador v-if="currentPostType ==='professions' || currentPostType ==='educations'" class="container margin-bottom-lg margin-top-xl" />
			
			<RelatedPosts class="related-articles" :data="relatedNewsData"/>
		</template>
		<PasswordProtection  v-else />
	</main>
</template>


<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import RelatedPosts from '@/components/modules/Posts'
import FeaturedImage from '@/components/parts/FeaturedImage'
import SocialShareArticle from '@/components/elements/SocialShareArticle'
import PasswordProtection from '@/components/parts/PasswordProtection'
import ConnectedEducations from '@/components/parts/ConnectedEducations'
import ConnectedAmbasador from '@/components/parts/ConnectedAmbasador'

import { mapGetters } from 'vuex';

export default {
	name: 'single-post',
	components:{
		ModuleBuilder,
		FeaturedImage,
		PasswordProtection,
		SocialShareArticle,
		RelatedPosts,
		ConnectedEducations,
		ConnectedAmbasador
	},
	computed: {
        ...mapGetters([
			'currentPageID',
			'currentPage',
			'currentPostType'
		]),
		isProtected(){
			let isProtected = false;
			if(this.currentPage && this.currentPage.is_protected === true){
				isProtected = true
			}
			return isProtected;
		},
		relatedNewsData(){
			if(!this.currentPageID) return null;
			let taxonomy = 'category';
			let category = this.currentPage.categories ? this.currentPage.categories.map(c=> c.id).join(',') : null;
			let title = this._('Relaterte artikler');
			
			if(this.currentPostType === 'professions'){
				taxonomy = 'work_place';
				category = this.currentPage.acf && this.currentPage.acf.work_place ? this.currentPage.acf.work_place : null;
				title = this._('Sjekk ut disse yrkene');
			}

			if(this.currentPostType === 'teachers'){
				title = this._('Mer innhold for rådgivere og lærere');
			}

			if(this.currentPostType === 'educations'){
				title = this._('Hva med disse utdanningene?');
				taxonomy = 'education_level';
				category = this.currentPage.acf && this.currentPage.acf.education_level ? this.currentPage.acf.education_level : null;
			}

			if(this.currentPostType === 'ambassadors'){
				taxonomy = 'category_ambasador';
				category = this.currentPage.acf && this.currentPage.acf.category ? this.currentPage.acf.category.map(c=> c).join(',') : null;
				title = this._('Historier fra andre ambassadører');
			}
			
			return {
				title,
				archive: true,
				type: this.currentPostType,
				limit: 3, 
				exclude : this.currentPageID,
				category,
				taxonomy

			}
		}
	}
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.single.post{
	.related-articles{
		.modle-title{
			text-align: center;
		}
	}
	.page-image{

		position: relative;
		z-index: 20;
		margin-top: -353px;
		margin-top: calc( -353px - 5.25vw);
		@include mquery(1260px){
			margin-top: -28.12%;
			margin-top: calc( -28.12% - 5.25vw);
		}
		.wp-image-vue .image{
			border-radius: $blocksRadius;
		}
	}
}

</style>